import { Sidebar, SidebarBody, SidebarFooter } from '@/components/catalyst-ui/sidebar'
import { WorkspaceSidebar } from './WorkspaceSidebar'
import { ProjectSidebar } from './ProjectSidebar'
import { UserAccountMenu } from './UserAccountMenu'
import { useSelectionStore } from '@/state/selection.store'
import { useLocation } from 'react-router-dom'

export default function AppSidebar() {
  const { activeProjectId = true } = useSelectionStore()
  const location = useLocation()
  const isWorkspaceLevelRoute =
    location.pathname === '/' ||
    location.pathname === '/projects' ||
    location.pathname === '/draft-generations'

  return (
    <Sidebar>
      <SidebarBody>
        {activeProjectId && !isWorkspaceLevelRoute ? <ProjectSidebar /> : <WorkspaceSidebar />}
      </SidebarBody>
      <SidebarFooter>
        <UserAccountMenu />
      </SidebarFooter>
    </Sidebar>
  )
}
